import { render, staticRenderFns } from "./pointGoodsDetail.vue?vue&type=template&id=56207312&scoped=true&"
import script from "./pointGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./pointGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./pointGoodsDetail.vue?vue&type=style&index=0&id=56207312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56207312",
  null
  
)

export default component.exports